import React,{useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate,faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import PriceModuleAddForm from './component/PriceModuleAddForm'
import PriceModuleList from './component/PriceModuleList'
import { timezoneOffset } from '../../../../../component/common/Helper';
import NoDataFound from '../../../../../component/common/NoDataFound';
import Pagination from '../../../../../component/common/pagination/Pagination';
import PriceModuleSkeleton from './component/PriceModuleSkeleton';
const PricingModule = () => {

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const [showLoader, setShowLoader] = useState(true);
    const [page, setPage] = useState(1);
    const [pricingModuleData, setPricingModuleData] = useState([])
    const [ paginationData, setPaginationData ] = useState({})
    const [pricingDataCount, setPricingDataCount] = useState(0)
    const [isRefresh, setIsRefresh] = useState(false)

    const [moduleUpdateData, setModuleUpdateData] = useState({})

    const getDataLimit = 50;

    const getPricingList = async () => {
        setShowLoader(true)
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }

        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };

        let reqData = {
            page: page,
            limit: getDataLimit,
            search_date: {},
            timeZone: timezoneOffset()
        }

        await axios.post(`${api_base_url}api/get-cms-pricing-list`, reqData, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                setPricingModuleData(res.data.data.data)
                setPaginationData({
                    current_pages : res.data.data.current_pages,
                    total_data_count : res.data.data.total_count,
                    total_pages : res.data.data.total_pages,
                    limit : res.data.data.limit,
                    data_length : res.data.data.data.length
                })

                // props.refreshSuccess()
                setPricingDataCount(res.data.data.total_count)

            } else if(res.data.status === 'error') {
                console.error('error')
            }
            setShowLoader(false)
            setIsRefresh(false)
        })
        .catch((error) => {
            setShowLoader(false)
            console.error(error);
        })
    }

    const pagechangeHandler = (pageNumber, type) => {
        if( type === 'previous' ){
            setPage((c_page) => c_page - 1)
        }else if( type === 'page' ){
            setPage(pageNumber)
        }
        else if( type === 'next' ){
            setPage((c_page) => c_page + 1)
        }
    }

    useEffect(() => {
        getPricingList()
    },[page, isRefresh])


    const deletePriceModuleOnClickHandler = async (dataParam) => {
        await Swal.fire({
            text: 'Are you sure to delete this record ?',
            icon: 'error',
            showCancelButton: true,
            showConfirmButton : true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK, Delete',
        }).then(async (result) => {
            if (result.isConfirmed) {
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                var api_headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "x-access-token" : apiToken
                    }
                };
                await axios.post(`${api_base_url}api/delete-price-module`, dataParam, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        toast.success(res.data.message);
                        setIsRefresh(true)
                    } else if(res.data.status === 'error') {
                        console.error('error')
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
            }   
        })
    }

    const updatePriceModuleOnClickHandler = (dataParam) => {
        console.log('dataParam', dataParam)
        const {id} = dataParam;
        const updatedData = pricingModuleData.find(item => item.id === id);
        setModuleUpdateData(updatedData)
    }


    const pricingDataNotFound = (
        <tr>
            <td colSpan="4" className="text-center">
                <NoDataFound className="w-30" setHtml="No data found" />
            </td>
        </tr>
    );


    let priceModuleHtml = ``;
    if(pricingModuleData.length > 0){
        priceModuleHtml = pricingModuleData.map((resData, index) => 
            <PriceModuleList
                key={index}
                data={resData}
                deletePriceModuleOnClick={deletePriceModuleOnClickHandler}
                updatePriceModuleOnClick={updatePriceModuleOnClickHandler}
            />
        )
    }

    const hasData = pricingModuleData.length > 0;
    const noData = !showLoader && !hasData;


    return (
        <>
            <div className="row">
                <div className="col-md-4">
                    <PriceModuleAddForm
                        formSubmitted={(data) => {
                            if(!data) return
                            setIsRefresh(data)
                        }}
                        moduleUpdateData={moduleUpdateData}
                    />
                </div>
                <div className="col-md-8">
                    <div className="card card-flush border">
                        <div className="card-header pe-5">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800 fs-2">
                                    Pricing List
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total {pricingDataCount} chat report are available
                                </span>
                            </h3>
                        </div>
                        <div className="card-body py-0">
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="fw-bold fs-6 text-gray-800">
                                            <th>Module Name</th>
                                            <th>Price</th>
                                            <th>Description</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            noData &&
                                            pricingDataNotFound
                                        }
                                        {
                                            hasData &&
                                            <>
                                                {priceModuleHtml}
                                            </>
                                        }
                                        {
                                            showLoader &&
                                            <PriceModuleSkeleton
                                                rows={10}
                                            />
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    {
                        hasData &&
                        <Pagination
                            pagination_data={paginationData}
                            onClick={pagechangeHandler}
                        />
                    }
                </div>
            </div>
        </>
    )
}

export default PricingModule